import { CloseOutlined } from "@ant-design/icons";
import { Alert, Modal, Spin, Typography } from "antd";
import React from "react";
import { useGetCallTranscriptQuery } from "../../../service/calls.service";
import styles from "./transcript-modal.module.scss";

const { Title, Paragraph } = Typography;

interface TranscriptModalProps {
  callId: number | null;
  callName: string;
  onClose: () => void;
}

const TranscriptModal: React.FC<TranscriptModalProps> = ({ callId, callName, onClose }) => {
  const { data, isLoading, error } = useGetCallTranscriptQuery(callId!, {
    skip: !callId,
  });

  return (
    <Modal
      open={callId !== null}
      onCancel={onClose}
      footer={null}
      width={800}
      closeIcon={<CloseOutlined />}
      className={styles.transcriptModal}
    >
      <div className={styles.transcriptModal__content}>
        <Title level={4} className={styles.transcriptModal__title}>
          Call Transcript - {callName}
        </Title>

        {isLoading && (
          <div className={styles.transcriptModal__loading}>
            <Spin size="large" />
          </div>
        )}

        {error && (
          <Alert
            message="Error Loading Transcript"
            description="Unable to fetch the call transcript. Please try again later."
            type="error"
            showIcon
          />
        )}

        {data && !isLoading && (
          <div className={styles.transcriptModal__transcript}>
            {data.transcript ? (
              <Paragraph className={styles.transcriptModal__text}>
                {data.transcript.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </Paragraph>
            ) : (
              <Alert
                message="No Transcript Available"
                description="This call does not have a transcript available."
                type="info"
                showIcon
              />
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default TranscriptModal;
